import React, { FC, useState } from 'react';
import { Tabs as BaseTabs } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import { setActiveMenuItem } from '../../shared/redux/commonSlice';

interface TabsProps {
  selected: number;
}

const Tabs: FC<TabsProps> = (props) => {
  const [value, setValue] = useState(props.selected);
  const dispatch = useDispatch();

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);

    dispatch(setActiveMenuItem(newValue));
  };

  return (
    <BaseTabs value={value} onChange={handleChange}>
      {props.children}
    </BaseTabs>
  );
};

export default Tabs;
